import { render, staticRenderFns } from "./BookingsInProgress.vue?vue&type=template&id=0358392a"
import script from "./BookingsInProgress.vue?vue&type=script&lang=js"
export * from "./BookingsInProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports